import * as THREE from "three";
import { useEffect, useState } from "react";
import { useMapStore } from "../../store/useMapStore.js";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
import fetchTopographyData from "./TopographyQueries.js";
import TopographyGeometry from "./TopographyGeometry.jsx";
import GUI from "lil-gui";
import { useEntityStore } from "../../store/useExportStore.js";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { useTopographyPropertiesStore } from "../../store/useGeometryPropertiesStore.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import BuildingGeometry from "../Buildings/Buildingcomponent.jsx";
import { useLayerStore } from "../../store/useLayerStore.js";
import { CacheGeometry,LoadFromCache,GetCacheKey, ClearCache} from "../../utils/GeometryHelper.js";

export default function TopographyComponent() {
  const setTopographyEntity1 = useEntityStore((state) => state.setTopographyEntity);
  const [topographyEntity, setTopographyEntity] = useState([]);
  const { setGeometryType } = useGeometryTypeStore();
  const updateTopographyPropertyStore = useTopographyPropertiesStore((state)=> state.updateTopographyProperties);
  const [crs, setCrs] = useState("EPSG25832"); 
  const updateMapView = useMapStore((state) => state.updateMapView);
  const updateElevationRangeMin = useMapStore((state) => state.updateElevationRangeMin);
  //const setTopographyEntities = useTopographyExportStore((state)=> state.setTopographyEntity);
  const scalingFactor = useMapStore((state) => state.scalingFactor);
  const boundingBoxNE = useBoundingBoxStore((state) => state.ne);
  const boundingBoxSW = useBoundingBoxStore((state) => state.sw);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const visibleLayers = useLayerStore((state) => state.visibleLayers);
  const setTopographyExport = useSiteExportStore((state) => state.setTopographyEntity);
  const clearTopography = useEntityStore((state) => state.clearTopography);
  const CACHE_KEY = "cacheTopography";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
  useEffect(() => {
    
    const fetchData = async () => {
      try {
          let topography;// = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
          if(!topography)
          {
            topography = await fetchTopographyData(
              boundingBoxNE.lng,
              boundingBoxNE.lat,
              boundingBoxSW.lng,
              boundingBoxSW.lat,
              crs
            );
            if (topography){setTopographyEntity(topography);
   
              setTopographyExport(topography)

              ClearCache(CACHE_KEY);
              //CacheGeometry(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY, CACHE_VERSION, topography)
              updateElevationRangeMin((topography.elevationRange.minimum + topography.elevationRange.maximum)/2); // To transform the 2D site plane
            } 
          }
          else{
            
           setTopographyExport(topography)

          }

        
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    if (boundingBoxNE && boundingBoxSW) fetchData();
  }, [crs, boundingBoxNE, boundingBoxSW]); 

  const handleEntitySelect = (entity) => 
  {
    console.log("Topography entity", entity.name)
    setSelectedEntityId(entity.id);
    setGeometryType(entity.name);
    updateTopographyPropertyStore(entity.breitengrad,entity.laengengrad, entity.nhn, entity.referenceSystem)
    
  }
  const handleBackgroundClick = () => 
    {
      setSelectedEntityId(null);
    };

  return (
    <>
      {topographyEntity && topographyEntity.mercatorCoordinates && (
        <TopographyGeometry
          entity={topographyEntity}
          scalingFactor={scalingFactor}
          selectedEntityId={selectedEntityId}
          setSelectedEntityId={setSelectedEntityId}
          onEntitySelect={handleEntitySelect}
          className = {"TopographyEntity"}
          visibilty={visibleLayers.topographie}
          
        />
         
      )}
   
    </>
  );
}
